// Hyperliquid-Live-Store. V1-Pendant: `livePrices` + `liveMetrics` in useHyperliquidGlobal.js.
// Kein persist — Daten kommen pro Session frisch vom WS.

import { create } from 'zustand';
import type { HLLiveMetrics, HLLivePrices } from '@/types/hyperliquid';

export interface HyperliquidState {
  livePrices: HLLivePrices;
  liveMetrics: HLLiveMetrics;
  /** Unix-ms wann der WebSocket zuletzt eine Nachricht geliefert hat. */
  lastMessageAt: number | null;
  isConnected: boolean;
}

export interface HyperliquidActions {
  setPrices: (prices: HLLivePrices) => void;
  mergePrices: (delta: HLLivePrices) => void;
  setMetric: (coin: string, metric: HLLiveMetrics[string]) => void;
  setConnected: (connected: boolean) => void;
  setLastMessageAt: (ts: number) => void;
  reset: () => void;
}

export type HyperliquidStore = HyperliquidState & HyperliquidActions;

const initial: HyperliquidState = {
  livePrices: {},
  liveMetrics: {},
  lastMessageAt: null,
  isConnected: false,
};

export const useHyperliquidStore = create<HyperliquidStore>()((set) => ({
  ...initial,
  setPrices: (livePrices) => set({ livePrices }),
  mergePrices: (delta) => set((s) => ({ livePrices: { ...s.livePrices, ...delta } })),
  setMetric: (coin, metric) =>
    set((s) => ({ liveMetrics: { ...s.liveMetrics, [coin]: metric } })),
  setConnected: (isConnected) => set({ isConnected }),
  setLastMessageAt: (lastMessageAt) => set({ lastMessageAt }),
  reset: () => set({ ...initial }),
}));

export const selectLivePrices = (s: HyperliquidState): HLLivePrices => s.livePrices;
export const selectLiveMetrics = (s: HyperliquidState): HLLiveMetrics => s.liveMetrics;
export const selectIsConnected = (s: HyperliquidState): boolean => s.isConnected;
